import axios from 'axios';
import Cookies from 'js-cookie';

const API_URL = process.env.VUE_APP_API_URL || '';

const authHeaders = () => ({
  headers: {
    Authorization: `Bearer ${Cookies.get('jwt')}`
  }
});

export default {
  /**
   * Tabela de dificuldades (pagamento, meta, trabalhos) definida no servidor
   */
  getConfig() {
    return axios.get(`${API_URL}/api/minigame/config`, authHeaders());
  },

  /**
   * Inicia uma sessão de minigame para o player autenticado.
   * O servidor valida os trabalhos diários e devolve a config oficial.
   * @param {string} minigame - 'fuga' | 'block-construction' | 'forge-merge'
   * @param {string} difficulty - nível de dificuldade
   */
  startMinigame(minigame, difficulty) {
    return axios.post(`${API_URL}/api/minigame/start`, { minigame, difficulty }, authHeaders());
  },

  /**
   * Completa a sessão ativa. Pagamento e trabalhos são calculados no servidor.
   */
  completeMinigame() {
    return axios.put(`${API_URL}/api/minigame/complete`, {}, authHeaders());
  },
};

/**
 * Extrai a mensagem de erro no formato Strapi 5
 */
export function getMinigameErrorMessage(error, fallback = 'Erro no minigame') {
  return error?.response?.data?.error?.message || error?.message || fallback;
}
